"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromBase64url = exports.toBase64url = void 0;
const base64_1 = require("multiformats/bases/base64");
function toBase64url(b) {
    return base64_1.base64url.encode(b).slice(1);
}
exports.toBase64url = toBase64url;
function fromBase64url(s) {
    return base64_1.base64url.decode(`u${s}`);
}
exports.fromBase64url = fromBase64url;
//# sourceMappingURL=utils.js.map